<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <!--dossierHeader [title]="'General.utils' | translate" [titleIcon]="'fa fa-cogs'"></dossierHeader-->
  <div class="container-fluid ">
    <div class="row">
      <div class="col-12">
        <div *ngFor=" let group of configGroups; let odd=odd; let even=even;">
          <div *ngIf="!group.profiles || userService.hasRoles(group.profiles)" [ngClass]="{ odd: odd, even: even }"
            class="group">
            <!-- <div>
              <span>{{group.title}}</span>
            </div> -->
            <div>
              <ul style="list-style-type: none;" class="ulClass">
                <ng-container *ngFor="let option of group.options">
                  <li
                    *ngIf="option.profiles===undefined|| option.profiles==='' || userService.hasRoles(option.profiles)"
                    class="liClass">
                    <a *ngIf="option.linkTo!=undefined&&option?.externalLink===true"
                      class="no-underline hover-bg-blue4 hover-white" target="_blank" [href]="[option.linkTo]">
                      <div class="shadow-hover hover-bg-white hide-child">
                        <div class="liDivIcon">
                          <i class="fa" [ngClass]="option.icon" style="font-size: 48px;"></i>
                        </div>
                        <div class="liDivText">
                          <span class="text-navy db select-all gray5 hover-gray7 text">{{option.text |
                            translate}}</span>
                        </div>
                      </div>
                    </a>
                    <a *ngIf="option.linkParams!=undefined
                    && option.linkParams!=''
                    && (option.externalLink===undefined||option.externalLink!=true)"
                      [routerLink]="[option.linkTo, option.linkParams]" class="no-underline hover-bg-blue4 hover-white">
                      <div class="shadow-hover hover-bg-white hide-child">
                        <div class="liDivIcon">
                          <i class="fa" [ngClass]="option.icon" style="font-size: 48px;"></i>
                        </div>
                        <div class="liDivText">
                          <span class="text-navy db select-all gray5 hover-gray7 text">{{option.text |
                            translate}}</span>
                        </div>
                      </div>
                    </a>
                    <a *ngIf="(option.externalLink===undefined||option.externalLink!=true) &&
                    (option.linkParams==undefined||option.linkParams=='')" [routerLink]="[option.linkTo]"
                      class="no-underline hover-bg-blue4 hover-white">
                      <div class="shadow-hover hover-bg-white hide-child">
                        <div class="liDivIcon">
                          <i class="fa" [ngClass]="option.icon" style="font-size: 48px;"></i>
                        </div>
                        <div class="liDivText">
                          <span class="text-navy db select-all gray5 hover-gray7 text">{{option.text |
                            translate}}</span>
                        </div>
                      </div>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>